<template>
    <div class="diagram-d-e-text-info-box">
        <span v-if="!fromShare && textValue != '' && !editable" class="diagram-d-e-edit" :class="editClassName" @click="clickEdit"><span>编辑</span></span>
        <div v-if="textValue != '' && !editable" class="diagram-d-e-info">
            <p v-html="UTILS.getBreakLineByText(textValue)"></p>
        </div>
        <div v-else-if="fromShare" class="diagram-d-e-info">
            <p v-if="textValue == ''">无</p>
            <p v-else v-html="UTILS.getBreakLineByText(textValue)"></p>
        </div>
        <div v-else class="diagram-d-e-textarea-box">
            <textarea class="diagram-d-e-textarea" name="" id="" cols="30" rows="3" :placeholder="placeholderText" @focus="focusTextArea" @blur="blurTextArea" v-model="textStr" maxlength="1000"></textarea>
            <div class="diagram-fake-textarea" @click="clickFakeTextArea"></div>
        </div>
    </div>
</template>


<script>
import { DIAGRAM_DOM } from '../../modules/dom';
import { UA, UTILS } from '../../modules/utils';
export default {
    name: 'DiagramEditPanel',
    props: {
        fromShare: {
            type: Boolean,
            default() { return false }
        },
        textKey: {
            type: String,
            default() { return '' }
        },
        textValue: {
            type: String,
            default() { return '' }
        },
        placeholderText: {
            type: String,
            default() { return '' }
        },
        saveFunc: {
            type: Function,
            default() { return null }
        },
        editClassName: {
            type: String,
            default() { return '' }
        }
    },
    data() {
        return {
            UTILS: UTILS,
            editable: false,
            textStr: '',
            textChanged: false,
            curFakeTextNode: null,
            focused: false
        }
    },
    mounted: function() {

    },
    methods: {
        clickEdit() {
            this.editable = true;
            this.textStr = this.textValue;
        },
        clickFakeTextArea(event) {
            let curNode = event.target,
                textNode = curNode.previousElementSibling;
            this.curFakeTextNode = curNode;
            this.curFakeTextNode.style = 'display: none';
            textNode.focus();

            // 光标定位到文本末尾
            var leng = this.textStr.length;
            textNode.setSelectionRange(leng, leng);
            console.log('clickFakeTextArea', event.target)

            this.$store.state.diagram.diagramDetailEdited = true;
            // if(UA.isIphone()) {
                DIAGRAM_DOM.updateDiagramDetailEditPanelStyle(curNode);
            // }
        },
        focusTextArea() {
            this.focused = true;
        },
        blurTextArea() {
            this.focused = false;
            // 处理样式
            this.$store.state.diagram.diagramDetailEdited = false;
            if(this.curFakeTextNode != null) {
                this.curFakeTextNode.style = '';
            }
            DIAGRAM_DOM.updateDiagramDetailStyle();

            // 处理数据
            let changed = this.textStr != this.textValue;
            if(!changed) { 
                this.editable = false;
                return;
            }
            if(this.saveFunc && typeof(this.saveFunc) == 'function') {
                this.saveFunc(this.textKey, this.textStr, () => {
                    this.editable = false;
                    this.textStr = '';
                });
            }
            // 处理软键盘问题
            console.log('fix white-111--', UA.isAndroid());
            if(UA.isAndroid()) {
                window.scrollTo(0, 0);
                console.log('fix white-222--');
                window.onresize = function() {
                    console.log('fix white-333--');
                    setTimeout(() => {
                        window.scrollTo(0, 0);
                    }, 300);
                }
            }
        },
        
    }
}
</script>